import React from 'react';
import { EmptyLayout, MainLayout } from 'components/layout';

// const FormioBuilder = React.lazy(() => import("components/formio/FormioBuilder"));
const SurveyList = React.lazy(() => import("components/admin/survey/SurveyList"));
const SurveyEditor = React.lazy(() => import("components/admin/survey/SurveyEditor"));
const FormCompile = React.lazy(() => import("components/formio/FormCompile"));
const SurveyInstanceResult = React.lazy(() => import("components/admin/survey/instance/SurveyInstanceResult"));

export const routes = [
    {
        component: SurveyList,
        exact: true,
        path: "/survey/list",
        authRequired: true,
        layout:MainLayout,
    },
    {
        component: SurveyEditor,
        exact: true,
        path: "/survey/add",
        authRequired: true,
        layout:MainLayout,
    },
    {
        component: SurveyEditor,
        exact: true,
        path: "/survey/update/:id(\\d+)",
        authRequired: true,
        layout:MainLayout,
    }, //-----------------------------FORMIO
    {
        component: FormCompile,
        exact: true,
        path: "/survey/compile/:id(\\d+)",
        authRequired: false,
        layout:EmptyLayout,
    },
    {
        component: SurveyInstanceResult,
        exact: true,
        path: "/survey/instance/:uuid",
        authRequired: false,
        layout:EmptyLayout,
    },
    // {
    //     component: FormioBuilder,
    //     exact: true,
    //     path: "/survey-builder",
    //     authRequired: true,
    //     layout:MainLayout,
    // },
];
